import Vue from 'vue';
import VueRouter from 'vue-router';
import buildGuards from './guards';
import routes from './routes';

const useRouter = (baseUrl) => {
  Vue.use(VueRouter);

  const router = new VueRouter({
    mode: 'history',
    base: baseUrl,
    routes,
  });

  buildGuards(router);

  return router;
};

export default useRouter;
